define((require) => {
    "use strict";

    var Marionette            = require("marionette"),
        ShareRecipientToLabel = require("ui/share/ShareRecipientToLabel"),
        template              = require("ui/share/ShareRecipientDisplayView.tpl");

    /**
     * Display item view for a share recipient.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipientDisplayView
     * @constructor
     */
    return Marionette.ItemView.extend({
        template: template,
        className: "recipients-list-item-wrapper",

        ui: {
            removeButton: ".recipients-list-item-remove-button"
        },

        bindings: {
            ".recipients-list-item": "displayName"
        },

        events: {
            "click": function() {
                this.model.set("selected", !this.model.get("selected"));
            }
        },

        onRender: function() {
            this.stickit();
            if (this.model instanceof ShareRecipientToLabel) {
                this.$el.addClass("to-label");
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/share/ShareRecipientDisplayView.js